import { BASE_URL } from "@/constants/util.js"
import { getAuthHeaders } from "@/api/auth.js"
import axios from "@/api/axiosAuthRequired.js"
import store from "../modules/store"

export const generatePaymentIntent = async body => {
  try {
    const url = `${BASE_URL}payments/gateways/stripe/cart-payment-intent`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    store.commit("Payment/setPaymentError", error.response.data.message)
    return null
  }
}

export const loadUserStripeCards = async () => {
  try {
    const url = `${BASE_URL}user/account/payment-methods/stripe/payment-methods/cards`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const fetchAvailablePromoCodesOffersByKey = async key => {
  try {
    const url = `${BASE_URL}promo-codes/offers/by-key/${key}`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}
export const fetchPromoCodesOffersForBootcamp = async bootcampKey => {
  try {
    const url = `${BASE_URL}promo-codes/offers/for-bootcamp/${bootcampKey}`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const fetchAvailablePromoCodes = async () => {
  try {
    const url = `${BASE_URL}promo-codes/offers`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const fetchAppliedPromoCodes = async () => {
  try {
    const url = `${BASE_URL}promo-codes/applied`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export const redeemPromoCodes = async promoCode => {
  const url = `${BASE_URL}promo-codes/redeem`
  const config = {
    headers: getAuthHeaders(),
  }
  const body = {
    code: promoCode,
  }
  const res = await axios.post(url, body, config)
  return res.data
}

export const redeemPromoCodeOffer = async promoCode => {
  try {
    const url = `${BASE_URL}promo-codes/offers/redeem`
    const config = {
      headers: getAuthHeaders(),
    }
    const body = {
      promo_code_offer_id: promoCode,
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const generateSetupIntent = async body => {
  try {
    const url = `${BASE_URL}payments/gateways/stripe/setup-intent`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}



// WEBPACK FOOTER //
// ./src/store/payment/payment.apis.js